import ApiBase from '../ApiBase';

class SuspendedStock extends ApiBase {
    /**
     * @method fetch
     * @param {number} page
     * @param {object} filters
     * @param {string} includes
     * @param {object} order
     * @return {Promise<*>}
     */
    fetch = (page, filters = {}, includes = '', order = {}) => this.get('suspended-stocks', {
        page,
        ...filters,
        includes,
        ...order
    });

    update = (items, status, data = {}) => this.patch('suspended-stocks', {
        items,
        status,
        ...data,
    }, 'update');
}

export default new SuspendedStock();
